// @ts-nocheck
import { MODULE_ACL } from "./constant";
import { parseModuleOperations } from "./voicePlanAcl";

export const VOICE_LIBRARY_ACL_MODULE = MODULE_ACL.VOICE_LIBRARY;

export const VOICE_TYPE_OPTIONS = [
  { label: "Incoming", value: "incoming" },
  { label: "Outgoing", value: "outgoing" },
  { label: "Both", value: "both" },
];

const ACL_BOOLEAN_OPS = ["read", "add", "edit", "delete", "view_permission"];

export function getVoiceLibraryAclEntry(moduleOperations) {
  const ops = parseModuleOperations(moduleOperations);
  return ops[VOICE_LIBRARY_ACL_MODULE] || null;
}

export function getVoiceLibraryAclRestrictions(moduleOperations, isSuperAdmin) {
  if (isSuperAdmin) {
    return null;
  }

  const entry = getVoiceLibraryAclEntry(moduleOperations);
  if (!entry) return null;

  const voiceTypes = normalizeVoiceTypes(entry.voice_types);
  const languages = normalizeStringList(entry.languages);

  if (voiceTypes.length === 0 && languages.length === 0) {
    return null;
  }

  return {
    voice_types: voiceTypes.length > 0 ? voiceTypes : null,
    languages: languages.length > 0 ? languages : null,
  };
}

export function isVoiceLibraryAclActive(moduleEntry) {
  if (!moduleEntry) return false;
  return ACL_BOOLEAN_OPS.some((op) => moduleEntry[op] === true);
}

export function isVoiceLibraryAclConfigured(moduleEntry) {
  if (!moduleEntry) return false;
  return (
    normalizeVoiceTypes(moduleEntry.voice_types).length > 0 &&
    normalizeStringList(moduleEntry.languages).length > 0
  );
}

export function normalizeVoiceTypes(types) {
  if (!Array.isArray(types)) return [];
  const valid = VOICE_TYPE_OPTIONS.map((o) => o.value);
  return [
    ...new Set(
      types
        .map((t) => String(t).trim().toLowerCase())
        .filter((t) => valid.includes(t))
    ),
  ];
}

export function normalizeStringList(values) {
  if (!Array.isArray(values)) return [];
  return [
    ...new Set(
      values.map((v) => String(v).trim()).filter((v) => v.length > 0)
    ),
  ];
}

export function normalizeVoiceLibraryAclForSave(
  { voice_types, languages },
  parentRestrictions = null,
  masterLists = {}
) {
  const allTypes = VOICE_TYPE_OPTIONS.map((o) => o.value);
  const typePool =
    parentRestrictions?.voice_types?.length > 0
      ? parentRestrictions.voice_types
      : allTypes;
  const languagePool =
    parentRestrictions?.languages?.length > 0
      ? parentRestrictions.languages
      : (masterLists.languages || []).map((l) => l.value);

  return {
    voice_types: normalizeVoiceTypes(voice_types).filter((t) =>
      typePool.includes(t)
    ),
    languages: normalizeStringList(languages).filter((l) =>
      languagePool.includes(l)
    ),
  };
}

export function getVoiceTypeOptionsForEditor(moduleOperations, isSuperAdmin) {
  if (isSuperAdmin) return VOICE_TYPE_OPTIONS;
  const restrictions = getVoiceLibraryAclRestrictions(
    moduleOperations,
    false
  );
  if (!restrictions?.voice_types) return VOICE_TYPE_OPTIONS;
  return VOICE_TYPE_OPTIONS.filter((o) =>
    restrictions.voice_types.includes(o.value)
  );
}

export function getLanguageOptionsForEditor(
  moduleOperations,
  isSuperAdmin,
  allLanguages = []
) {
  if (isSuperAdmin) return allLanguages;
  const restrictions = getVoiceLibraryAclRestrictions(
    moduleOperations,
    false
  );
  if (!restrictions?.languages) return allLanguages;
  return allLanguages.filter((o) => restrictions.languages.includes(o.value));
}

export function getParentGrantableVoiceLibraryRestrictions(
  moduleOperations,
  isSuperAdmin
) {
  if (isSuperAdmin) return null;
  return getVoiceLibraryAclRestrictions(moduleOperations, false);
}

export function formatVoiceLibraryAclLabel(moduleEntry) {
  if (!moduleEntry || !isVoiceLibraryAclConfigured(moduleEntry)) return "—";
  const types = normalizeVoiceTypes(moduleEntry.voice_types).length;
  const langs = normalizeStringList(moduleEntry.languages).length;
  return `${types} type(s), ${langs} lang.`;
}

export function filterVoiceTypesByAcl(moduleOperations, isSuperAdmin) {
  if (isSuperAdmin) return VOICE_TYPE_OPTIONS;
  const restrictions = getVoiceLibraryAclRestrictions(
    moduleOperations,
    false
  );
  if (!restrictions?.voice_types) return VOICE_TYPE_OPTIONS;
  return VOICE_TYPE_OPTIONS.filter((o) =>
    restrictions.voice_types.includes(o.value)
  );
}

export function filterLanguagesByAcl(
  moduleOperations,
  isSuperAdmin,
  allLanguages = []
) {
  if (isSuperAdmin) return allLanguages;
  const restrictions = getVoiceLibraryAclRestrictions(
    moduleOperations,
    false
  );
  if (!restrictions?.languages) return allLanguages;
  return allLanguages.filter((l) => restrictions.languages.includes(l.value));
}
